// src/seedScorePages/Auth/ResendVerification/ResendVerification.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../Auth.css';
import logo from '../../../assets/images/seedxpert-light.png';

const ResendVerification = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();

    const handleResendVerification = async (e) => {
        e.preventDefault();
        if (!email) {
            setMessage('Lütfen email adresinizi girin');
            return;
        }

        setIsLoading(true);
        try {
            const response = await axios.post('/api/auth/resend-verification', { email });
            setMessage(response.data.msg);
            setIsSuccess(true);
        } catch (err) {
            setMessage(err.response?.data?.msg || 'Bir hata oluştu');
            setIsSuccess(false);
        }
        setIsLoading(false);
    };

    return (
        <div className="auth-container">
            <div className="bg-animation">
                <div className="floating-shape shape-1"></div>
                <div className="floating-shape shape-2"></div>
                <div className="floating-shape shape-3"></div>
                <div className="floating-shape shape-4"></div>
                <div className="floating-shape shape-5"></div>
                <div className="floating-shape shape-6"></div>
                <div className="floating-shape shape-7"></div>
            </div>

            <div className="auth-box">
                <div className="logo-section">
                    <img 
                        src={logo} 
                        alt="SeedXpert Logo" 
                        className="auth-logo" 
                    />
                </div>

                <div className="auth-header">
                    <h2>Email Doğrulama Linki Gönder</h2>
                    <p className="auth-subtitle">
                        Doğrulama linkiniz süresi dolmuş veya kaybolmuşsa, yeni bir tane gönderebiliriz
                    </p>
                </div>

                {message && (
                    <p className={isSuccess ? 'success' : 'error'}>
                        {message}
                    </p>
                )}

                {!isSuccess && (
                    <form onSubmit={handleResendVerification}>
                        <div className="form-group">
                            <label>Email Adresi</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Email adresinizi girin"
                                required
                            />
                        </div>

                        <button type="submit" className="auth-btn primary-btn" disabled={isLoading}>
                            {isLoading ? (
                                <>
                                    <span className="loading-spinner"></span>
                                    Gönderiliyor...
                                </>
                            ) : (
                                'Doğrulama Linki Gönder'
                            )}
                        </button>
                    </form>
                )}

                <div className="auth-footer">
                    <p className="switch-text">
                        <span className="switch-link" onClick={() => navigate('/')}>
                            ← Giriş sayfasına dön
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ResendVerification;